import { useQuery } from '@tanstack/react-query'
import { supabase } from '@/lib/supabase'

export function useRegions() {
  return useQuery({
    queryKey: ['psgc-regions'],
    queryFn: async () => {
      const { data, error } = await supabase
        .from('psgc_regions')
        .select('psgc_code, name')
        .order('name')
      if (error) throw error
      return data
    },
    staleTime: Infinity,
  })
}

export function useProvinces(regionPsgc: string | null) {
  return useQuery({
    queryKey: ['psgc-provinces', regionPsgc],
    enabled: !!regionPsgc,
    queryFn: async () => {
      const { data, error } = await supabase
        .from('psgc_provinces')
        .select('psgc_code, name')
        .eq('parent_psgc_code', regionPsgc!)
        .order('name')
      if (error) throw error
      return data
    },
    staleTime: Infinity,
  })
}

export function useCitiesMunis(provincePsgc: string | null) {
  return useQuery({
    queryKey: ['psgc-cities-munis', provincePsgc],
    enabled: !!provincePsgc,
    queryFn: async () => {
      const { data, error } = await supabase
        .from('psgc_cities_munis')
        .select('psgc_code, name')
        .eq('parent_psgc_code', provincePsgc!)
        .order('name')
      if (error) throw error
      return data
    },
    staleTime: Infinity,
  })
}

export function useBarangays(cityMuniPsgc: string | null) {
  return useQuery({
    queryKey: ['psgc-barangays', cityMuniPsgc],
    enabled: !!cityMuniPsgc,
    queryFn: async () => {
      const { data, error } = await supabase
        .from('psgc_barangays')
        .select('psgc_code, name')
        .eq('parent_psgc_code', cityMuniPsgc!)
        .order('name')
      if (error) throw error
      return data
    },
    staleTime: Infinity,
  })
}

export function usePuroksForBarangayPsgc(barangayPsgc: string | null) {
  return useQuery({
    queryKey: ['puroks-by-psgc', barangayPsgc],
    enabled: !!barangayPsgc,
    queryFn: async () => {
      const { data: entity } = await supabase
        .from('entities')
        .select('id, status')
        .eq('psgc_code', barangayPsgc!)
        .eq('level', 'barangay')
        .maybeSingle()
      if (!entity || entity.status !== 'active') return []
      const { data, error } = await supabase
        .from('puroks')
        .select('id, name')
        .eq('barangay_entity_id', entity.id)
        .eq('is_active', true)
        .order('name')
      if (error) throw error
      return data ?? []
    },
  })
}
